import React, { PureComponent } from 'react';

import { WebItems } from '@atlassian/bitbucket-connect-react';

import { commitFileTarget, CommitFileTargetProps } from 'src/connect/targets';

import { WebItemButton } from './file-actions.style';

type FileActionsProps = CommitFileTargetProps & {
  principalId: string;
};

export class FileActions extends PureComponent<FileActionsProps> {
  render() {
    const { principalId, path, hash, repositoryOwner, repositorySlug } =
      this.props;

    return (
      <WebItems
        location="org.bitbucket.source.file.actions"
        principalId={principalId}
        target={commitFileTarget({
          path,
          hash,
          repositoryOwner,
          repositorySlug,
        })}
        component={WebItemButton}
        loadingComponent={() => null}
      >
        {items => <span data-qa="connect-source-file-actions">{items}</span>}
      </WebItems>
    );
  }
}
